// Feature Documentation: docs/features/external-case-table-modern.md
// Feature Documentation: docs/features/org-specific-home-pages.md
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import GlobalSearchResults from './components/GlobalSearchResults';
import ExternalCaseTable from "./components/ExternalCaseTable";
import CodingSearch from './components/CodingQuality/CodingSearch';
import CptRulesManager from './components/CptRules/CptRulesManager';
import CptHistoryViewer from './components/CptRules/CptHistoryViewer';
import IONMStrictAnalysis from './components/StrictAnalysis/index';
import NMAV2Compare from './components/StrictAnalysis/NMAV2Compare';


import PayerPolicyResearch from './components/PayerPolicyResearch';
import PayerCurationDashboard from './components/PayerCurationDashboard';
import NMAStrictDashboard from './components/NMAStrictDashboard';
import NMAWorkflowDashboard from './components/NMAWorkflowDashboard';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import SuperAdminBillingDashboard from './components/SuperAdminBillingDashboard';
import ProjectList from './components/ProjectWorkspace/ProjectList';
import ProjectDetail from './components/ProjectWorkspace/ProjectDetail';
import ZinniaxReconciliationDashboard from './components/ZinniaxReconciliationDashboard';

import NMAComplianceDashboard from './components/NMAComplianceDashboard';
import NMACodingQualityDashboard from './components/NMACodingQualityDashboard';
import NMAV2QualityDashboard from './components/NMAV2QualityDashboard';

import USNComprehensiveDashboard from './components/USNComprehensiveDashboard';
import USNCodingQualityDashboard from './components/USNCodingQualityDashboard';
import USNClaimsFirstPassDashboard from './components/USNClaimsFirstPassDashboard';
import USNV2QualityDashboard from './components/USNV2QualityDashboard';
import USNV2Compare from './components/StrictAnalysis/USNV2Compare';
import MPHCodingQualityDashboard from './components/MPHCodingQualityDashboard';
import MPHSaQualityDashboard from './components/MPHSaQualityDashboard';
import MPHSurgicalAssistAnalysis from './components/MPHSurgicalAssistAnalysis';
import MPHSAV2Compare from './components/StrictAnalysis/MPHSAV2Compare';

import BackendCheck from './components/BackendCheck';
import TermsAndConditions from './components/TermsAndConditions';
import CodeIOMNew from './components/IOMnew';
import ReviewDashboard from './components/ReviewDashboard';
import ReviewCase from './components/ReviewCase';

import GenerateNote from './components/GenerateNote';
import GenerateTranscript from './components/GenerateTranscript';
// import Chat from './components/Chat';
import LoginPage from './loginpage';
import Admin from './components/Admin';
import ClientAdmin from './components/ClientAdmin';
import OrgChatExplorer from './components/OrgChatExplorer';
import ConfigAdmin from './components/ConfigAdmin';
import ClientManagement from './components/ClientManagement';
import EdfExtractionDemo from './components/EdfExtractionDemo';
import APIDocs from './components/APIDocs';
import APIDocsOrchestrate from './components/APIDocsOrchestrate';
import APIDocsV2 from './components/APIDocsV2';
import FullCPTCoderAPIDocs from './components/FullCPTCoderAPIDocs';
import APIDocsPublic from './components/APIDocsPublic';
import APITemplateDocs from './components/APITemplateDocs'; // Template Management API documentation - comprehensive guide for template endpoints
import CaseServiceTable from './components/CaseServiceTable';
import ModernCaseTable from './components/ModernCaseTable';
import ExternalCaseTableModern from './components/ExternalCaseTableModern';
import { WebSocketProvider } from './components/WebSocket';
import { AppContextProvider } from './components/AppContext'; // adjust the import based on your project structure
import CreateNote from './components/CreateNote';
import ABN from './components/ABN';
import StripeCheckout from './components/StripeCheckout';
import FqLayout from './components/fq/FqLayout';
import FqIntake from './components/fq/FqIntake';
import FqClaimDetail from './components/fq/FqClaimDetail';
import FqDashboard from './components/fq/FqDashboard';
import FqClaimsList from './components/fq/FqClaimsList';
import FqPreSubmissionQueue from './components/fq/FqPreSubmissionQueue';
import Fq835ReviewQueue from './components/fq/Fq835ReviewQueue';
import FqDemoMedicalNecessity from './components/fq/FqDemoMedicalNecessity';
import FqDemoBox80 from './components/fq/FqDemoBox80';
import FqDemoSameDayRestraint from './components/fq/FqDemoSameDayRestraint';
import FqDemoAppealDraft from './components/fq/FqDemoAppealDraft';
import FqDemoCodeIntelligence from './components/fq/FqDemoCodeIntelligence';
import FqDemoCarveOutAnalyzer from './components/fq/FqDemoCarveOutAnalyzer';
import FqDemoWrapCompliance from './components/fq/FqDemoWrapCompliance';
import FqDemoDenialIntelligence from './components/fq/FqDemoDenialIntelligence';

import FqPaLayout from './components/fq-pa/FqPaLayout';
import FqPaIntake from './components/fq-pa/FqPaIntake';
import FqPaClaimDetail from './components/fq-pa/FqPaClaimDetail';
import FqPaDashboard from './components/fq-pa/FqPaDashboard';
import FqPaClaimsList from './components/fq-pa/FqPaClaimsList';
import FqPaPreSubmissionQueue from './components/fq-pa/FqPaPreSubmissionQueue';
import FqPa835ReviewQueue from './components/fq-pa/FqPa835ReviewQueue';
import FqPaDemoMedicalNecessity from './components/fq-pa/FqPaDemoMedicalNecessity';
import FqPaDemoBox80 from './components/fq-pa/FqPaDemoBox80';
import FqPaDemoSameDayRestraint from './components/fq-pa/FqPaDemoSameDayRestraint';
import FqPaDemoAppealDraft from './components/fq-pa/FqPaDemoAppealDraft';
import FqPaDemoCodeIntelligence from './components/fq-pa/FqPaDemoCodeIntelligence';
import FqPaDemoCarveOutAnalyzer from './components/fq-pa/FqPaDemoCarveOutAnalyzer';
import FqPaDemoWrapCompliance from './components/fq-pa/FqPaDemoWrapCompliance';
import FqPaDemoDenialIntelligence from './components/fq-pa/FqPaDemoDenialIntelligence';

import FileUpload from './components/FileUpload';
import EncounterAnalysis from './components/EncounterAnalysis';
import EncounterAnalysisV2 from './components/EncounterAnalysisV2';
import EncounterList from './components/EncounterList';
import EncounterListV2 from './components/EncounterListV2';
import StripeThankYou from './components/StripeThankYou';
import CodingGuidelines from './components/CodingGuidelines';
import GuidelinesLayout from './components/mph-guidelines/GuidelinesLayout';
import Icd10SaHpGuideline from './components/mph-guidelines/Icd10SaHpGuideline';
import Icd10ModifiersGuideline from './components/mph-guidelines/Icd10ModifiersGuideline';
import NMAGuidelinesLayout from './components/nma-guidelines/NMAGuidelinesLayout';
import NMADxCodingLogic from './components/nma-guidelines/NMADxCodingLogic';
import NMACptCodingLogic from './components/nma-guidelines/NMACptCodingLogic';
import NMAMetaAnalysisReport from './components/NMAMetaAnalysisReport';
import ExternalIONMCase from './components/IONMExternalCase';
import LogViewer from './components/LogViewer';
import EncountersTable from './components/ProviderEncountersTable';
import EncountersTableAdmin from './components/ProviderEncountersTableAdmin';
import EncounterDetailPage from './components/EncounterDetailPage';
import CognitiveAssessment from './components/APICognitiveAssessment';
import PayerResponseGenerator from './components/PayerResponseGenerator';
import MedicalNecessityAnalysis from './components/MedicalNecessityAnalysis';
import ExternalCaseManager from './components/ExternalCaseManager';
import TemplateManager from './components/TemplateManager';
import PDFTemplateManager from './components/PDFTemplateManager';
import BrandingManager from './components/BrandingManager';
import TemplateList from './components/TemplateList';
import ContentExplorer from './components/content_explorer/ContentExplorer';
import CaseImpactPortfolio from './components/CaseImpactPortfolio';
import CodingVarianceReport from './components/CodingVarianceReport';
import CodingVarianceDashboard from './components/CodingVarianceDashboard';
import MPHCodingVarianceDashboard from './components/MPHCodingVarianceDashboard';
import MPHCodingVarianceReview from './components/variance/MPHCodingVarianceReview';
import MPHDemoCodingVarianceDashboard from './components/MPHDemoCodingVarianceDashboard';
import NMADemoDashboard from './components/NMADemoDashboard';
import NMAClaimsDashboard from './components/NMAClaimsDashboard';
import NMAAppealsDashboard from './components/NMAAppealsDashboard';
import NMAAppealDetail from './components/NMAAppealDetail';
import RetrospectiveDemoDashboard from './components/RetrospectiveDemoDashboard';


import IONMCodingDocs from './components/APIIONMdocs';
import APIIONMdemo from './components/APIIONMdemo';
import CPTCaseCoder from './components/CPTCaseCoder';
//import FullCPTCoder from './components/FullCPTCoder';
import FullCPTCoder from './components/FullCPTCoderModern';
import CaseWizard from './components/CaseWizard';
import PilotUploader from './components/PilotUploader';
import PilotPlaceholder from './components/PilotPlaceholder';
import { useFeatureFlags } from './components/FeatureFlags';
import IONMDocumentation from './components/IONMDocumentation';
import EncounterNoteEdit from './components/EncounterNoteEdit';
import CaseDataViewer from './components/CaseDataViewer';
import IONMReview from './components/IONMReview';
import CodingReviewDetail from './components/CodingReviewDetail';
import IONMCasesSimple from './components/IONMCasesSimple';
import Overview from './components/Overview';
import RevedyDemo from './components/RevedyDemo';
import RevedyImplementation from './components/RevedyImplementation';
import AnalyticsDashboard from './components/AnalyticsDashboard';
import AnalysisResults from './components/AnalysisResults';
import AnalyzeCase from './components/AnalyzeCase';
import AnalyzeCaseMN from './components/AnalyzeCaseMN';
import PayerResponseIntelligence from './components/PayerResponseIntelligence';
import PayerResponseViewer from './components/PayerResponseViewer';
import PayerResponsesDashboard from './components/PayerResponsesDashboard';
import PayerResponseQueue from './components/PayerResponseQueue';
import WorkflowManagement from './components/WorkflowManagement';
import ClaimCodingDashboard from './components/ClaimCodingDashboard';
import PayerResponseWorkflow from './components/PayerResponseWorkflow';
import ClaimAnalysisDashboard from './components/ClaimAnalysisDashboard';
import ClaimAnalysisList from './components/ClaimAnalysisList';
import MedicalNecessityWorkflow from './components/MedicalNecessityWorkflow';
import CPTCodingWorkflow from './components/CPTCodingWorkflow';
import IONMWorkflow from './components/IONMWorkflow';
import NatusProposal from './components/NatusProposal';
import BulkUpload from './components/BulkUpload';
import CaseResultsReport from './components/CaseResultsReport';
import AdmissionStatusAnalysis from './components/AdmissionStatusAnalysis';
import ManualCPTDashboard from './components/ManualCPTDashboard';
import ManualCPTUpload from './components/ManualCPTUpload';
import ManualCPTReviewPage from './components/ManualCPTReviewPage';
import ManualReviewResults from './components/ManualReviewResults';
import ConfigurationAccuracyDashboard from './components/ConfigurationAccuracyDashboard';
import AthenaDemo from './components/AthenaDemo';
import EvalCodingComparison from './components/EvalCodingComparison';

import {
  extendTheme,
  ChakraProvider,
  Box,
} from '@chakra-ui/react';
import APIWorkflows from './components/APIWorkflows';
import IframeIntegrationDocs from './components/IframeIntegrationDocs';
import EDFManager from './components/EDF/EDFManager';
import JobsDashboard from './components/JobsDashboard';
import MphReviewFeedback from './components/MphReviewFeedback';

const colors = {
  brand: {
    900: '#8ECAE6', //light blue
    800: '#219EBC', //blue
    700: '#023047', //dark blue
    600: '#FFB703', //yellow
    500: '#FB8500' //orange
  },
};

const theme = extendTheme({
  colors,
  components: {
    Text: {
      baseStyle: {
        fontSize: "sm",
        fontWeight: "normal",
      },
    },
  },
});

const HomeRouter = () => {
  const { featureFlags } = useFeatureFlags();
  const userRole = featureFlags?.user_role;

  if (userRole === 'pilot') {
    return <PilotUploader />;
  }

  return <FullCPTCoder />;
};

const OrgHomeRedirect = () => {
  const { featureFlags } = useFeatureFlags();
  
  // Get the logo path from the menu structure, default to /search
  const homePath = featureFlags?.menu_structure?.logo?.path || '/search';
  
  return <Navigate to={homePath} replace />;
};

// Wrapper to force full component remount when caseId changes
const ReviewCaseWrapper = () => {
  const { caseId } = require('react-router-dom').useParams();
  return <ReviewCase key={caseId} />;
};

function App() {
  const [dataReceived, setDataReceived] = useState(false);

  const [results, setResults] = useState(undefined);
  
  const handleDataReceived = (results) => {
    console.log ("data received");    
    setDataReceived(true);
    setResults(results);
  };

  const [PTdataReceived, PTsetDataReceived] = useState(false);
  const [PTresults, PTsetResults] = useState(undefined);
  const [errorMessage, setErrorMessage] = useState(null);

  const PThandleDataReceived = (PTresults) => {
    console.log ("data received");    
    PTsetDataReceived(true);
    PTsetResults(PTresults);
  };


  return (
    <Router>
      <AppContextProvider>
        <Routes>
          <Route path="/search" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <ChakraProvider theme={theme}>
                  <GlobalSearchResults />
                </ChakraProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />

          <Route path="/edf-extraction" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <ChakraProvider theme={theme}>
                  <EdfExtractionDemo />
                </ChakraProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />

          {/* good - terms and conditions as part of new user registration */}
          <Route path="/terms" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <TermsAndConditions />
            </ProtectedRoute>
          } />
          <Route path="/admin/content-explorer" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><WebSocketProvider><ChakraProvider theme={theme}><ContentExplorer /></ChakraProvider></WebSocketProvider></BackendCheck></ProtectedRoute>} />
          <Route path="/impact-portfolio" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><CaseImpactPortfolio /></ChakraProvider></BackendCheck></ProtectedRoute>} />
          <Route path="/coding-variance" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><CodingVarianceReport /></ChakraProvider></BackendCheck></ProtectedRoute>} />
          <Route path="/coding-variance-dashboard" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><CodingVarianceDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
          <Route path="/mph-coding-variance-dashboard" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MPHCodingVarianceDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
          <Route path="/mph-coding-variance/:caseId" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MPHCodingVarianceReview /></ChakraProvider></BackendCheck></ProtectedRoute>} />
          <Route path="/demo-coding-variance-dashboard" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MPHDemoCodingVarianceDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
          <Route path="/nma-demo-dashboard" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMADemoDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
          <Route path="/retrospective-analysis-demo" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><RetrospectiveDemoDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />

          {/* good -used for full cpt coding */}
          <Route  path="/" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <WebSocketProvider>
                  <ChakraProvider theme={theme}>
                      <OrgHomeRedirect />
                  </ChakraProvider>
                </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />  
          
          {/* good - used for login error message*/}
          <Route path="/login" element={
            <ChakraProvider theme={theme}>
              <LoginPage />
            </ChakraProvider>
          } />

          {/* good - used for new user data collection*/}
            

            {/* good - used for new user coding guidelines data collection*/}
            <Route path="/coding-guidelines" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                      <ChakraProvider theme={theme}>
                          <CodingGuidelines />
                      </ChakraProvider>
              </ProtectedRoute>
            } />

            {/* good - displays IONM coded with CADWELL JSON */}
            <Route path="/review-dashboard" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <ChakraProvider theme={theme}>
                    <ReviewDashboard />
                  </ChakraProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />
            <Route path="/review/:caseId" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <ChakraProvider theme={theme}>
                    <ReviewCaseWrapper />
                  </ChakraProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />
                          <Route path="/ionmform" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>              
                    <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <CodeIOMNew />
                      </ChakraProvider>
                    </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            {/* good - displays IONM mnemonics */}
            <Route path="/ionmcase" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>              
                    <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <ExternalIONMCase />
                      </ChakraProvider>
                    </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - log viewer for error messages  */}
            <Route path="/logviewer" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>              
                    <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <LogViewer />
                      </ChakraProvider>
                    </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - list of encounters with notes */}
            <Route path="/encounters" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>              
                    <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <EncountersTable />
                      </ChakraProvider>
                    </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            
            <Route path="/coding-search" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                      <ChakraProvider theme={theme}>
                          <CodingSearch />
                      </ChakraProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            <Route path="/cpt-rules" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                      <ChakraProvider theme={theme}>
                          <CptRulesManager />
                      </ChakraProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            <Route path="/cpt-history" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                      <ChakraProvider theme={theme}>
                          <CptHistoryViewer />
                      </ChakraProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            <Route path="/external-cases" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <ChakraProvider theme={theme}>
                  <ExternalCaseTable />
                </ChakraProvider>
              </BackendCheck>
              </ProtectedRoute>
            } />


            {/*good - table for IONM Cadwell cases  */}
            <Route path="/ionmtable" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <CaseServiceTable />
                      </ChakraProvider>
                      </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            <Route path="/ionmtable-modern" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <ModernCaseTable />
                      </ChakraProvider>
                  </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            <Route path="/external-cases-modern" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <ExternalCaseTableModern />
                      </ChakraProvider>
                  </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            <Route path="/new-case" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <CaseWizard />
                      </ChakraProvider>
                  </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - used to see how API works for note transcription etc  */}
            <Route path="/ea" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <EncounterAnalysis />
                      </ChakraProvider>
                      </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - used to see how API works for note transcription etc  */}
            <Route path="/eav2" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <EncounterAnalysisV2 />
                      </ChakraProvider>
                      </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - used to see how api works for getting lists of notes  */}
            <Route path="/el" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <EncounterList />
                      </ChakraProvider>
                      </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

                        {/*good - used to see how api works for getting lists of notes  */}
            <Route path="/elv2" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <EncounterListV2 />
                      </ChakraProvider>
                      </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            {/*Review - might be useful - not sure it works  */}
            <Route path="/securefiles" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                          <FileUpload />
                      </ChakraProvider>
                      </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            {/* keep, just goes to goes to full-cpt-coder  */}
            <Route path="/home" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                  <WebSocketProvider>
                      <ChakraProvider theme={theme}>
                        <OrgHomeRedirect />
                      </ChakraProvider>
                    </WebSocketProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            {/* Pilot User Placeholder Page */}
            <Route path="/processing" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                    <ChakraProvider theme={theme}>
                      <PilotPlaceholder />
                    </ChakraProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            {/* Direct Route for Pilot Uploader */}
            <Route path="/pilot-upload" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                  <BackendCheck>
                    <ChakraProvider theme={theme}>
                      <PilotUploader />
                    </ChakraProvider>
                  </BackendCheck>
              </ProtectedRoute>
            } />

            {/*Review - maybe we should keep and extend? public api docs */}
            <Route path="/api" element={
                    <ChakraProvider theme={theme}>
                      <APIDocsPublic />
                    </ChakraProvider>
            } />

            {/*good - current api dcos  */}
            <Route path="/apidocsv1" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                      <APIDocs />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />


            {/*good - current api dcos  */}
            <Route path="/api-docs" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                      <APIDocsV2 />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />


            {/* Orchestration API Docs */}
            <Route path="/api-docs-orchestrate" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                      <APIDocsOrchestrate />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - CPT and ICD-10 coding api docs  */}
            <Route path="/cpt-icd-api-docs" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                      <FullCPTCoderAPIDocs />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - Template Management API documentation - provides comprehensive documentation for template CRUD operations, AI generation, and organization management */}
            <Route path="/template-api-docs" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                      <APITemplateDocs />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - current api dcos  */}
            <Route path="/api-workflows" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                      <APIWorkflows />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            {/*good - iframe integration documentation */}
            <Route path="/iframe-integration" element={
              <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                      <IframeIntegrationDocs />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
              </ProtectedRoute>
            } />

            {/*keep - see how the API can be used to generate notes  */}
            <Route path="/generate" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <GenerateNote />
                    </ChakraProvider>
                  </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />

            {/*for deletion - interface to do healthcare chats 
            <Route path="/chat" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <Chat />
                    </ChakraProvider>
                  </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />
          */}

            {/*good - scribe capabilities   */}
            <Route path="/transcribe" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <GenerateTranscript />
                    </ChakraProvider>
                  </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />

            {/*good - scribe capabilities same page as /transcribe  */}
            <Route path="/scribe" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <GenerateTranscript />
                    </ChakraProvider>
                  </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />

          {/* used internally by /generate to create the note */}
          <Route path="/create-note" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <WebSocketProvider>
                  <ChakraProvider theme={theme}>
                    <CreateNote />
                  </ChakraProvider>
                </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />

            {/*good - purchase pages  */}
            <Route path="/checkout" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <WebSocketProvider>
                  <ChakraProvider theme={theme}>
                    <StripeCheckout />
                  </ChakraProvider>
                </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />

            {/*good - purchase pages  */}
            <Route path="/thankyou" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <WebSocketProvider>
                  <ChakraProvider theme={theme}>
                    <StripeThankYou />
                  </ChakraProvider>
                </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />

            {/*good - used by admin - don't link to it though  */}
            <Route path="/admin" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <Admin />
                    </ChakraProvider>
                  </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          } />
          
            {/*client admin - can put in menu  */}
            <Route path="/client-admin" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ClientAdmin />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />
          <Route path="/org-chat-explorer" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <OrgChatExplorer />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*client management - admin interface for managing clients per org  */}
            <Route path="/client-management" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ClientManagement />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            <Route path="/config-admin" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ConfigAdmin />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*assess - probably keep but needs review  */}
            <Route path="/abn/:docId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ABN />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*delete - but save case defintion for cognitive assessment  */}
            <Route path="/cognitive-api" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <CognitiveAssessment />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*keep - this is primary for IONM and probably can be used for other cases  */}
            <Route path="/medical-necessity-analysis" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <MedicalNecessityAnalysis />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*keep for now - shows deprecated page  */}
            <Route path="/external-case-manager" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ExternalCaseManager />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*keep - shows details of encounters, linked from encountersadmin  */}
            <Route path="/encounter/:encounterId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <EncounterDetailPage />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/* template management interface - allows admin users to create and manage note templates */}
            <Route path="/templatemanager" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <TemplateManager />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

          {/* template list display - shows available note templates for users to browse and select */}
          <Route path="/templatelist" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <TemplateList />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

          {/* PDF template management interface - allows users to manage logos for PDF templates */}
          <Route path="/settings/pdf-templates" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <PDFTemplateManager />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*keep - good overview of notes encounters - needs cleanup */}
            <Route path="/encountersadmin" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <EncountersTableAdmin />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*good - api docs for IONM specifically  */}
            <Route path="/apiionm" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <IONMCodingDocs />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/* keep - part of showing how the IONM api works  */}
            <Route path="/apiionmdemo" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <APIIONMdemo />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/* keep - part of showing how the IONM api works  */}
            <Route path="/encounter-note-edit" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <EncounterNoteEdit />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />


        <Route path="/payer-response/:caseId/:claimId?" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <PayerResponseGenerator />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*  */}
            <Route path="/external-case-ionm" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ExternalIONMCase />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*delete - outdated  */}
            <Route path="/cpt-coder" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <CPTCaseCoder />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/* Legacy route redirect */}
            <Route path="/full-cpt-coder" element={<Navigate to="/search" replace />} />

            {/*keep - for showing how IONM works */}
            <Route path="/ionm-review" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <IONMReview />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />


            {/*keep - for showing how IONM works */}
            <Route path="/ionm-cases" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <IONMCasesSimple />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*keep - for showing how IONM works */}
            <Route path="/coding-review" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <CodingReviewDetail />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*keep - for showing how IONM works */}
            <Route path="/overview" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <Overview />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

            {/*keep - for showing how IONM works */}
            <Route path="/ionm-docs" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <IONMDocumentation />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/case-viewer" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <CaseDataViewer />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/rcm" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <RevedyDemo />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/implementation" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <RevedyImplementation />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />



        <Route path="/claims" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <AnalysisResults />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/reports/coding-results" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ClaimCodingDashboard />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/analyze-case/:caseId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <AnalyzeCase />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />


        <Route path="/analyze-case-mn/:caseId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <AnalyzeCaseMN />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/payer-response-intelligence/:caseId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <ChakraProvider theme={theme}>
                      <PayerResponseIntelligence />
                  </ChakraProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/case-appeals/:caseId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <PayerResponseViewer />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/payer-responses" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <PayerResponsesDashboard />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/denials-queue" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <ChakraProvider theme={theme}>
                      <PayerResponseQueue />
                  </ChakraProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/payer-workflow" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <PayerResponseWorkflow />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/claim-analysis/:caseId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                    <ChakraProvider theme={theme}>
                        <ClaimAnalysisDashboard />
                    </ChakraProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/claim-analysis-dashboard" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                    <ChakraProvider theme={theme}>
                        <ClaimAnalysisList />
                    </ChakraProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/medical-necessity-workflow" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <MedicalNecessityWorkflow />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/cpt-coding-workflow" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <CPTCodingWorkflow />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/ionm-workflow" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <IONMWorkflow />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/natus-proposal" element={
          <ChakraProvider theme={theme}>
            <NatusProposal />
          </ChakraProvider>
        } />


        <Route path="/case-results-report" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <CaseResultsReport />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/workflow/:caseId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <WorkflowManagement />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/bulk-upload" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <BulkUpload />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/case-admission-status/:caseId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <AdmissionStatusAnalysis />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/cpt-feedback-dashboard" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ManualCPTDashboard />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/cpt-feedback-review/:caseId" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ManualCPTReviewPage />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/cpt-feedback-upload" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ManualCPTUpload />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/cpt-feedback-results" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ManualReviewResults />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/cpt-feedback-configs" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
                <BackendCheck>
                  <WebSocketProvider>
                    <ChakraProvider theme={theme}>
                        <ConfigurationAccuracyDashboard />
                    </ChakraProvider>
                  </WebSocketProvider>
                </BackendCheck>
            </ProtectedRoute>
          } />

        <Route path="/athena-demo" element={
          <ProtectedRoute setErrorMessage={setErrorMessage}>
            <BackendCheck>
              <ChakraProvider theme={theme}>
                <AthenaDemo />
              </ChakraProvider>
            </BackendCheck>
          </ProtectedRoute>
        } />

        <Route path="/eval-coding-comparison" element={
          <ProtectedRoute setErrorMessage={setErrorMessage}>
            <BackendCheck>
              <ChakraProvider theme={theme}>
                <EvalCodingComparison />
              </ChakraProvider>
            </BackendCheck>
          </ProtectedRoute>
        } />

        <Route path="/branding" element={
          <ProtectedRoute setErrorMessage={setErrorMessage}>
            <BackendCheck>
              <ChakraProvider theme={theme}>
                <BrandingManager />
              </ChakraProvider>
            </BackendCheck>
          </ProtectedRoute>
        } />






                <Route path="/nma-compare-v3/:caseId" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAV2Compare /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/ionm-strict-analysis/:caseId" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><IONMStrictAnalysis /></ChakraProvider></BackendCheck></ProtectedRoute>} />
                <Route path="/nma-workflow" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAWorkflowDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
                <Route path="/super-admin-dashboard" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><SuperAdminDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
                <Route path="/super-admin-dashboard/billing" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><SuperAdminBillingDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
                <Route path="/projects" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><ProjectList /></ChakraProvider></BackendCheck></ProtectedRoute>} />
                <Route path="/projects/:id" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><ProjectDetail /></ChakraProvider></BackendCheck></ProtectedRoute>} />
                <Route path="/zinniax-reconciliation" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><ZinniaxReconciliationDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/nma-dashboard" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAStrictDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/nma-claims" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAClaimsDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/nma-appeals" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAAppealsDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/nma-appeals/:claimNumber" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAAppealDetail /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/nma-meta-analysis" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAMetaAnalysisReport /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/nma-compliance" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAComplianceDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
                <Route path="/nma-v3-cases" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMAV2QualityDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/nma-coding-quality" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><NMACodingQualityDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/usn-dashboard" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><USNComprehensiveDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/usn-coding-quality" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><USNCodingQualityDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/usn-claims" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><USNClaimsFirstPassDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/usn-v2-cases" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><USNV2QualityDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/usn-compare-v2/:caseId" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><USNV2Compare /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/mph-coding-quality" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MPHCodingQualityDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/mph-sa-quality" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MPHSaQualityDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/mph-surgical-assist/:caseId" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MPHSurgicalAssistAnalysis /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/mph-sa-compare-v2/:caseId" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MPHSAV2Compare /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/mph-compare-v2/:caseId" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MPHSAV2Compare /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/mph-review-feedback" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><MphReviewFeedback /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        
        {/* MPH Guidelines Mini-Site */}
        <Route path="/mph-guidelines" element={
          <ProtectedRoute setErrorMessage={setErrorMessage}>
            <BackendCheck>
              <ChakraProvider theme={theme}>
                <GuidelinesLayout />
              </ChakraProvider>
            </BackendCheck>
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="icd10-sa-hp" replace />} />
          <Route path="icd10-sa-hp" element={<Icd10SaHpGuideline />} />
          <Route path="icd10-modifiers" element={<Icd10ModifiersGuideline />} />
        </Route>

        {/* NMA Guidelines Mini-Site */}
        <Route path="/nma-guidelines" element={
          <ProtectedRoute setErrorMessage={setErrorMessage}>
            <BackendCheck>
              <ChakraProvider theme={theme}>
                <NMAGuidelinesLayout />
              </ChakraProvider>
            </BackendCheck>
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="dx-coding-logic" replace />} />
          <Route path="dx-coding-logic" element={<NMADxCodingLogic />} />
          <Route path="cpt-coding-logic" element={<NMACptCodingLogic />} />
        </Route>
        <Route path="/payer-research" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><PayerPolicyResearch /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/admin/payer-curation" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><PayerCurationDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/edf-generate" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><EDFManager /></ChakraProvider></BackendCheck></ProtectedRoute>} />
        <Route path="/jobs" element={<ProtectedRoute setErrorMessage={setErrorMessage}><BackendCheck><ChakraProvider theme={theme}><JobsDashboard /></ChakraProvider></BackendCheck></ProtectedRoute>} />

        
          {/* FQHC HMS Demo Routes */}
          <Route path="/fq" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <WebSocketProvider>
                  <ChakraProvider theme={theme}>
                    <FqLayout />
                  </ChakraProvider>
                </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          }>
            <Route path="dashboard" element={<FqDashboard />} />
            <Route path="intake" element={<FqIntake />} />
            <Route path="pre-submission" element={<FqPreSubmissionQueue />} />
            <Route path="835-review" element={<Fq835ReviewQueue />} />
            <Route path="claims" element={<FqClaimsList />} />
            <Route path="claim/:id" element={<FqClaimDetail />} />
            <Route path="claim/demo" element={<FqClaimDetail />} />
            <Route path="demo/medical-necessity" element={<FqDemoMedicalNecessity />} />
            <Route path="demo/box-80" element={<FqDemoBox80 />} />
            <Route path="demo/same-day-restraint" element={<FqDemoSameDayRestraint />} />
            <Route path="demo/appeal-draft" element={<FqDemoAppealDraft />} />
            <Route path="demo/code-intelligence" element={<FqDemoCodeIntelligence />} />
            <Route path="demo/carve-out-analyzer" element={<FqDemoCarveOutAnalyzer />} />
            <Route path="demo/wrap-compliance" element={<FqDemoWrapCompliance />} />
            <Route path="demo/denial-intelligence" element={<FqDemoDenialIntelligence />} />
          </Route>

          {/* FQHC PA Demo Routes */}
          <Route path="/fq-pa" element={
            <ProtectedRoute setErrorMessage={setErrorMessage}>
              <BackendCheck>
                <WebSocketProvider>
                  <ChakraProvider theme={theme}>
                    <FqPaLayout />
                  </ChakraProvider>
                </WebSocketProvider>
              </BackendCheck>
            </ProtectedRoute>
          }>
            <Route path="dashboard" element={<FqPaDashboard />} />
            <Route path="intake" element={<FqPaIntake />} />
            <Route path="pre-submission" element={<FqPaPreSubmissionQueue />} />
            <Route path="835-review" element={<FqPa835ReviewQueue />} />
            <Route path="claims" element={<FqPaClaimsList />} />
            <Route path="claim/:id" element={<FqPaClaimDetail />} />
            <Route path="claim/demo" element={<FqPaClaimDetail />} />
            <Route path="demo/medical-necessity" element={<FqPaDemoMedicalNecessity />} />
            <Route path="demo/box-80" element={<FqPaDemoBox80 />} />
            <Route path="demo/same-day-restraint" element={<FqPaDemoSameDayRestraint />} />
            <Route path="demo/appeal-draft" element={<FqPaDemoAppealDraft />} />
            <Route path="demo/code-intelligence" element={<FqPaDemoCodeIntelligence />} />
            <Route path="demo/carve-out-analyzer" element={<FqPaDemoCarveOutAnalyzer />} />
            <Route path="demo/wrap-compliance" element={<FqPaDemoWrapCompliance />} />
            <Route path="demo/denial-intelligence" element={<FqPaDemoDenialIntelligence />} />
          </Route>
        </Routes>
      </AppContextProvider> 
    </Router>
  );
}

export default App;

